/**
 * The body the mobile tRPC client posts for a call with no input, where
 * Android needs a JSON body; the api's transformer (@libs/api-kernel) reads it
 * back as no input. Clients import it through @libs/wire.
 */
const TRPC_NO_INPUT_SENTINEL_KEY = "__lissen_trpc_no_input__";

export const trpcNoInputSentinel = {
  [TRPC_NO_INPUT_SENTINEL_KEY]: true,
} as const;

export function isTrpcNoInputSentinel(
  value: unknown,
): value is typeof trpcNoInputSentinel {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return false;
  }

  const record = value as Record<string, unknown>;
  return (
    Object.keys(record).length === 1 &&
    record[TRPC_NO_INPUT_SENTINEL_KEY] === true
  );
}
